import { ITheme, Theme, ThemeProvider, useTheme } from "@fluentui/react";
import { getSuffixStyles } from "./styles";
import { useInputButtons } from "./useInputButtons";
import { useMemo } from "react";
import { CommandBar, ICommandBarItemProps } from "../../../components/CommandBar/CommandBar";
import { ThemeDesigner } from "../../ThemeDesigner";
import { useClassNames } from "../../../hooks/useClassNames";
import { DeepPartial, ICopyButton } from "../../../interfaces/components";
import { merge } from 'merge-anything'

export interface IInputButtons {
    value?: string | undefined;
    buttons?: ICommandBarItemProps[];
    clickToCopyProps?: ICopyButton["clickToCopyProps"]
    deleteButtonProps?: ICommandBarItemProps;
    disabled?: boolean;
    readOnly?: boolean;
    colors?: {
        backgroundColor: string,
        primaryColor: string,
        textColor: string
    }
    themeOverride?: DeepPartial<ITheme>;
}

export const InputButtons = (props: IInputButtons) => {
    const {colors} = {...props};
    const baseTheme = useTheme();

    const theme = useMemo(() => {
        const theme = ThemeDesigner.generateTheme({
            backgroundColor: colors?.backgroundColor ?? baseTheme.semanticColors.inputBackground,
            primaryColor: colors?.primaryColor ?? baseTheme.palette.themePrimary,
            textColor: colors?.textColor ?? baseTheme.palette.black
        });
        theme.semanticColors.menuBackground = baseTheme.semanticColors.menuBackground;
        return merge(theme, props.themeOverride ?? {}) as ITheme
    }, [colors?.backgroundColor, colors?.primaryColor, colors?.textColor, baseTheme]);
    //replace due to back comp with old CSS where it often targets the class name directly
    //the decision to add the properties as --propName directly to className instead of creating
    //another class was really unfortunate, we need to abandon this practice
    const classNames = useClassNames('Input-Buttons', {}).replace('--underlined', '');
    const suffixStyles = useMemo(() => getSuffixStyles(theme), [theme]);

    const { items } = useInputButtons(props, theme);

    if (!props.buttons && !props.clickToCopyProps && !props.deleteButtonProps) {
        return <></>
    }
    return <ThemeProvider className={`${classNames} ${suffixStyles.root}`} theme={theme} applyTo="none">
        <CommandBar
            items={[]}
            theme={theme}
            farItems={items} />
    </ThemeProvider>
}